import { render, staticRenderFns } from "./habilitarLancarNotaAnolectivo.vue?vue&type=template&id=0f514c15&"
import script from "./habilitarLancarNotaAnolectivo.vue?vue&type=script&lang=js&"
export * from "./habilitarLancarNotaAnolectivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports